export const COMPLIANCE_FORM_NAME = 'COMPLIANCE_FORM_NAME';
export const ONBOARDING_FORM_NAME = 'ONBOARDING_FORM_NAME';
